@if (nodeActionsService.grouping()) {
  <glxy-alert [showIcon]="false" type="info">
    <div class="group-alert">
      <div class="group-description">
        <strong>{{ 'AUTOMATIONS.GROUPING.SELECT_REQUIREMENTS' | translate }}</strong>
        &mdash; {{ 'AUTOMATIONS.GROUPING.NUM_SELECTED' | translate: { count: nodeActionsService.groupStepSize() } }}
      </div>
      <span class="group-button">
        <button (click)="cancelGroup()" mat-stroked-button data-action="”banner-cancel-group-clicked”">
          {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
        </button>
        <button
          [disabled]="nodeActionsService.groupStepSize() < 2"
          (click)="submitGroup()"
          mat-flat-button
          color="primary"
          data-action="”banner-create-group-clicked”"
        >
          {{ 'AUTOMATIONS.GROUPING.CREATE_GROUP' | translate }}
        </button>
      </span>
    </div>
  </glxy-alert>
}

<ng-container *ngTemplateOutlet="topBanners"></ng-container>
<ng-container *ngIf="automationLoadingError$ | async as err; else workflowViewer">
  <ng-container *ngTemplateOutlet="emptyState; context: { err: err }"></ng-container>
</ng-container>

<ng-template #workflowViewer>
  <automata-workflow-viewer-v2
    [automationId]="automationId"
    [readOnly]="readOnly"
    (changeSideMenuContent)="changeSideMenuContentEvent($event)"
  ></automata-workflow-viewer-v2>
</ng-template>

<ng-template #topBanners>
  <div class="errors-wrapper" *ngIf="(isTemplateView$ | async) === false && !readOnly">
    <div *ngIf="isPartnerViewingBuiltInAutomation$ | async">
      <glxy-alert type="info" [showClose]="false" size="small">
        <span [innerHTML]="'AUTOMATIONS.EDITOR.BUILT_IN_AUTOMATION.BANNER' | translate | iTrustThisHtml"></span>
      </glxy-alert>
    </div>
    <ng-container *ngIf="originBuiltInAutomation$ | async as originBuiltInAutomation">
      <div>
        <glxy-alert
          type="info"
          size="small"
          [showClose]="false"
          [showAction]="true"
          [actionTitle]="'AUTOMATIONS.EDITOR.AUTOMATION.BUILT_IN_ORIGIN.VIEW' | translate"
          [actionExternalLink]="'/automations/automation/' + originBuiltInAutomation.id + '/workflow'"
        >
          <ng-container *ngIf="originBuiltInAutomationOn$ | async; else builtInAutomationOffBanner">
            <span
              [innerHTML]="
                'AUTOMATIONS.EDITOR.AUTOMATION.BUILT_IN_ORIGIN.TURNED_ON_BANNER'
                  | translate
                    : {
                        built_in_automation_name: originBuiltInAutomation.name,
                      }
                  | iTrustThisHtml
              "
            ></span>
          </ng-container>
          <ng-template #builtInAutomationOffBanner>
            <span
              [innerHTML]="
                'AUTOMATIONS.EDITOR.AUTOMATION.BUILT_IN_ORIGIN.TURNED_OFF_BANNER'
                  | translate
                    : {
                        built_in_automation_name: originBuiltInAutomation.name,
                      }
                  | iTrustThisHtml
              "
            ></span>
          </ng-template>
        </glxy-alert>
      </div>
    </ng-container>

    <glxy-alert type="error" class="alert" size="small" *ngIf="showErrorBanner$ | async" [showClose]="false">
      <span [innerHTML]="'AUTOMATIONS.COMMON.ERRORS_FOUND' | translate | iTrustThisHtml"></span>
    </glxy-alert>
    <glxy-alert type="warning" class="alert" size="small" *ngIf="showMissingPermissions$ | async">
      <b>{{ 'AUTOMATIONS.PERMISSIONS.WARNING_TITLE' | translate }}</b>
      &mdash; {{ 'AUTOMATIONS.PERMISSIONS.WARNING_MESSAGE' | translate }}
    </glxy-alert>
    <glxy-alert type="warning" class="alert" size="small" *ngIf="showWarningBanner$ | async">
      <span [innerHTML]="'AUTOMATIONS.COMMON.WARNINGS_FOUND' | translate | iTrustThisHtml"></span>
    </glxy-alert>
    <glxy-alert
      type="warning"
      class="alert"
      size="small"
      [showClose]="true"
      (close)="closeWarning()"
      *ngIf="showCopyWarningBanner$ | async"
    >
      <strong>
        <span [innerHTML]="'AUTOMATIONS.COMMON.DUPLICATION_WARNING_FOUND.TITLE' | translate | iTrustThisHtml"></span>
      </strong>
      <span [innerHTML]="'AUTOMATIONS.COMMON.DUPLICATION_WARNING_FOUND.BODY' | translate | iTrustThisHtml"></span>
    </glxy-alert>
    <ng-container *ngIf="warnings$ | async as warnings">
      <ng-container *ngFor="let warning of warnings">
        <glxy-alert
          type="warning"
          class="alert"
          size="small"
          [showClose]="false"
          [showAction]="!!warning.helpArticleLink"
          [actionTitle]="'AUTOMATIONS.COMMON.LEARN_MORE' | translate"
          (actionClick)="goTo(warning.helpArticleLink)"
        >
          <span>{{ warning.translationKey | translate }}</span>
        </glxy-alert>
      </ng-container>
    </ng-container>
    <div *ngIf="tokenBroken$ | async">
      <glxy-alert
        type="warning"
        size="small"
        [showAction]="(isSettingsPage() | async) === false"
        [actionTitle]="'AUTOMATIONS.COMMON.TOKEN_BROKEN_BUTTON' | translate"
        (actionClick)="goToSettings()"
        [showClose]="false"
      >
        <span [innerHTML]="'AUTOMATIONS.COMMON.TOKEN_BROKEN' | translate"></span>
      </glxy-alert>
    </div>
  </div>
</ng-template>

<ng-template #emptyState let-err="err">
  <glxy-empty-state>
    <glxy-empty-state-hero>
      <img
        src="{{ getImageSource('images/empty-state/automation-empty-state.svg') }}"
        alt="{{ 'AUTOMATIONS.COMMON.AUTOMATION_NOT_FOUND.TITLE_OTHER' | translate }}"
      />
    </glxy-empty-state-hero>
    <glxy-empty-state-title [ngSwitch]="err.status">
      <span *ngSwitchCase="403">
        {{ 'AUTOMATIONS.COMMON.AUTOMATION_NOT_FOUND.TITLE_403' | translate }}
        ({{ err.status }})
      </span>
      <span *ngSwitchDefault>
        {{ 'AUTOMATIONS.COMMON.AUTOMATION_NOT_FOUND.TITLE_OTHER' | translate }}
        ({{ err.status }})
      </span>
    </glxy-empty-state-title>
    <div [ngSwitch]="err.status">
      <p *ngSwitchCase="403">
        {{ 'AUTOMATIONS.COMMON.AUTOMATION_NOT_FOUND.BODY_403' | translate }}
      </p>
      <p *ngSwitchCase="404">
        {{ 'AUTOMATIONS.COMMON.AUTOMATION_NOT_FOUND.BODY_404' | translate }}
      </p>
      <p *ngSwitchDefault>
        {{ 'AUTOMATIONS.COMMON.AUTOMATION_NOT_FOUND.BODY_OTHER' | translate }}
      </p>
    </div>
    <glxy-empty-state-actions>
      <a mat-flat-button color="primary" href="/automations">
        {{ 'AUTOMATIONS.COMMON.AUTOMATION_NOT_FOUND.BACK' | translate }}
      </a>
    </glxy-empty-state-actions>
  </glxy-empty-state>
</ng-template>
